import React from 'react'
import { StatusCellStyles } from './Style'
import { isEmpty } from 'lodash'
import { statuses } from 'keys'
import { performAssessmentsHooks } from '.'
import { Chip } from 'components/Form'
import { sub } from 'date-fns'

const StatusCell = (props) => {
    const { row } = props

    const { status, sub_status, assessment_group, status_type } = row.original

    const mappingByStatus = performAssessmentsHooks.useStatuses()
    let customStatus

    const undone = status == statuses.created
    const done = status == statuses.uploaded || status == statuses.uploading
    const inProgress = (status == statuses.inProgress && sub_status == statuses.wordsInProgress) || status == statuses.backToMarking
    const recheckPending = status == statuses.inProgress && sub_status == statuses.recheckPending
    const completed = status == statuses.inProgress && sub_status == statuses.wordsComplete
    const missed = status == statuses.missed
    const redo = status == statuses.redo || status == statuses.brokenFile
    const uploding = status == statuses.uploading

    if (undone) customStatus = mappingByStatus.undone
    if (done) customStatus = mappingByStatus.done
    if (inProgress) customStatus = mappingByStatus.inProgress
    if (recheckPending) customStatus = mappingByStatus.inProgress
    if (completed) customStatus = mappingByStatus.completed
    if (missed) customStatus = mappingByStatus.missed
    if (redo) customStatus = mappingByStatus.redo
    if (uploding) customStatus = mappingByStatus.uploading

        return(
            <StatusCellStyles>
                <Chip {...customStatus}>
                    {customStatus?.label}{status_type && ` - ${status_type}`}
                </Chip>
            </StatusCellStyles>
        )
}

export default StatusCell